/**
 * CZNA-593 — remembers the proposal list's ownership filter ("Vše / Jen moje / Moje
 * instituce") between sessions, per browser profile.
 *
 * <p>localStorage rather than a backend user setting: the choice is a viewing habit, not
 * data, and mod-czna-users has no per-user preference store to put it in. The cost of that
 * is that it does not follow the user to another machine — acceptable for a filter, and
 * reversible if a real preference store ever arrives.
 *
 * <p>Reads are defensive on purpose. A value written by an older build, hand-edited, or
 * left over from a renamed enum must degrade to the default rather than put the list into
 * a state no option in the Select can represent.
 */
import { DEFAULT_PROPOSAL_OWNERSHIP_FILTER, isProposalOwnershipFilter, } from '../types/api';
export var OWNERSHIP_FILTER_STORAGE_KEY = 'czna:proposals:ownershipFilter';
/**
 * localStorage throws in private mode and under some enterprise policies; a remembered
 * filter is never worth breaking the list over, so every access is guarded and failure
 * simply means "not remembered".
 */
var storage = function () {
    try {
        if (typeof window !== 'undefined' && window.localStorage) {
            return window.localStorage;
        }
    }
    catch (_a) {
        // SecurityError — fall through.
    }
    return null;
};
/** Returns the remembered filter, or the default when nothing valid is stored. */
export var readOwnershipFilter = function () {
    var store = storage();
    if (!store)
        return DEFAULT_PROPOSAL_OWNERSHIP_FILTER;
    try {
        var raw = store.getItem(OWNERSHIP_FILTER_STORAGE_KEY);
        return isProposalOwnershipFilter(raw) ? raw : DEFAULT_PROPOSAL_OWNERSHIP_FILTER;
    }
    catch (_a) {
        return DEFAULT_PROPOSAL_OWNERSHIP_FILTER;
    }
};
/**
 * Remembers the filter. The default is stored as an explicit removal rather than the
 * string "ALL" so that clearing filters really does go back to "nothing remembered".
 */
export var writeOwnershipFilter = function (value) {
    var store = storage();
    if (!store)
        return;
    try {
        if (value === DEFAULT_PROPOSAL_OWNERSHIP_FILTER) {
            store.removeItem(OWNERSHIP_FILTER_STORAGE_KEY);
        }
        else {
            store.setItem(OWNERSHIP_FILTER_STORAGE_KEY, value);
        }
    }
    catch (_a) {
        // QuotaExceeded / SecurityError — the filter just will not be remembered.
    }
};
